// Razorpay Checkout helper — loads the SDK on demand and opens the hosted modal.
// Returns a Promise that resolves with {order_id, payment_id, signature} on success,
// or rejects on user-cancel / payment failure.

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

let _loaded = null;
function loadScript() {
  if (_loaded) return _loaded;
  _loaded = new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay Checkout"));
    document.body.appendChild(s);
  });
  return _loaded;
}

/**
 * Open the Razorpay Checkout modal.
 *
 * @param {object} opts
 *   key                — RAZORPAY_KEY_ID (returned by backend `razorpay_key`)
 *   amount_paise       — integer amount in paise
 *   order_id           — Razorpay order_id (returned by backend)
 *   name, description  — branding strings
 *   prefill            — {name, email, contact}
 *   notes              — optional metadata object
 * @returns Promise<{ order_id, payment_id, signature }>
 */
export async function openRazorpayCheckout(opts) {
  await loadScript();
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: opts.key,
      amount: opts.amount_paise,
      currency: "INR",
      order_id: opts.order_id,
      name: opts.name || "Nirmal Privilege Card",
      description: opts.description || "NPC Membership",
      image: opts.image || undefined,
      prefill: opts.prefill || {},
      notes: opts.notes || {},
      theme: { color: "#0F2540" },
      handler: (r) => resolve({
        order_id: r.razorpay_order_id,
        payment_id: r.razorpay_payment_id,
        signature: r.razorpay_signature,
      }),
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
    });
    rzp.on("payment.failed", (e) => {
      reject(new Error(e?.error?.description || "Payment failed"));
    });
    rzp.open();
  });
}
